module.exports = __webpack_public_path__ + "img/paypal.142c0d52.svg";